import React from "react";
import "../../components/cards/css/card.css";
import { MdArrowOutward } from "react-icons/md";
const ServicesCard = (props) => {
  return (
    <div className="card">
      <div className="icon-container">
        <img src={props.icon} alt="" />
      </div>
      <p>{props.title}</p>
      <div className="view-more">
        <p>view more</p>
        <MdArrowOutward className="arrow" />
      </div>
    </div>
  );
};

export default ServicesCard;
